import { render, staticRenderFns } from "./HmwControl.vue?vue&type=template&id=292d81c0&scoped=true"
import script from "./HmwControl.vue?vue&type=script&lang=js"
export * from "./HmwControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292d81c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('292d81c0')) {
      api.createRecord('292d81c0', component.options)
    } else {
      api.reload('292d81c0', component.options)
    }
    module.hot.accept("./HmwControl.vue?vue&type=template&id=292d81c0&scoped=true", function () {
      api.rerender('292d81c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/controls/HmwControl.vue"
export default component.exports